// removed by extract-text-webpack-plugin
module.exports = {"portability_success":"styles__portability_success___lNdgy","button_full":"styles__button_full___2R-XS"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/FixedVoice/components/ActionForm/SuccessEdit/styles.css
// module id = 3161
// module chunks = 0